import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const StoreFrontFlowContent = lazy(() => import('./content'));

export const StoreFrontFlow = wrapNavigatorScreen(StoreFrontFlowContent, {
  headerShown: false,
});
